const LOG_TYPES = {
  KEYBOARD: 1,
  SCREENSHOTS: 2,
  PROGRAMS: 3,
  FILES: 4,
  CLIPBPARD: 5,
  PRINTER: 6,
  INSALLED_PROGRAMS: 7,
  EXTERNAL_DRIVERS: 8,
  VISITES_SITES: 10,
  COMPUTER: 11,
  SHADOW_COPYING: 14,
  E_MAIL_CLIENTS: 15,
  NETWORK_ACCESS: 18,
  NETWORK_FILES: 19,
  WEB_MAIL: 20,
  FILE_UPLOAD: 21,
  SOCIAL_NETWORKS: 22,
  MESSENGERS: 23,
  WEBCAM_AND_MICROPHONE: 24,
  HARDWARE_CHANGES: 25,
  SEARCH_QUERIES: 26,
  MIC_RECORDS: 27,
};

export const MAP_LOG_TYPES = {
  [LOG_TYPES.KEYBOARD]: 0,
  [LOG_TYPES.SCREENSHOTS]: 1,
  [LOG_TYPES.PROGRAMS]: 2,
  [LOG_TYPES.FILES]: 3,
  [LOG_TYPES.CLIPBPARD]: 4,
  [LOG_TYPES.PRINTER]: 5,
  [LOG_TYPES.INSALLED_PROGRAMS]: 6,
  [LOG_TYPES.EXTERNAL_DRIVERS]: 7,
  [LOG_TYPES.VISITES_SITES]: 8,
  [LOG_TYPES.COMPUTER]: 9,
  [LOG_TYPES.SHADOW_COPYING]: 10,
  [LOG_TYPES.E_MAIL_CLIENTS]: 11,
  [LOG_TYPES.NETWORK_ACCESS]: 12,
  [LOG_TYPES.NETWORK_FILES]: 13,
  [LOG_TYPES.WEB_MAIL]: 14,
  [LOG_TYPES.FILE_UPLOAD]: 15,
  [LOG_TYPES.SOCIAL_NETWORKS]: 16,
  [LOG_TYPES.MESSENGERS]: 17,
  [LOG_TYPES.WEBCAM_AND_MICROPHONE]: 18,
  [LOG_TYPES.HARDWARE_CHANGES]: 19,
  [LOG_TYPES.SEARCH_QUERIES]: 20,
  [LOG_TYPES.MIC_RECORDS]: 21,
};
